import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const PATIENT_INSURANCES_REQUEST = 'PATIENT_INSURANCES_REQUEST';
export const PATIENT_INSURANCES_SUCCESS = 'PATIENT_INSURANCES_SUCCESS';
export const PATIENT_INSURANCES_FAILURE = 'PATIENT_INSURANCES_FAILURE';

export const DOWNLOAD_INSURANCE_REQUEST = 'DOWNLOAD_INSURANCE_REQUEST';
export const DOWNLOAD_INSURANCE_SUCCESS = 'DOWNLOAD_INSURANCE_SUCCESS';
export const DOWNLOAD_INSURANCE_FAILURE = 'DOWNLOAD_INSURANCE_FAILURE';

export const DELETE_INSURANCE_REQUEST = 'DELETE_INSURANCE_REQUEST';
export const DELETE_INSURANCE_SUCCESS = 'DELETE_INSURANCE_SUCCESS';
export const DELETE_INSURANCE_FAILURE = 'DELETE_INSURANCE_FAILURE';

export const PATIENT_INSURANCE_REQUEST = 'PATIENT_INSURANCE_REQUEST';
export const PATIENT_INSURANCE_SUCCESS = 'PATIENT_INSURANCE_SUCCESS';
export const PATIENT_INSURANCE_FAILURE = 'PATIENT_INSURANCE_FAILURE';

export function requestPatientInsurances(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/insurance/transfer/search?${query}`,
      method: 'GET',
      types: ['PATIENT_INSURANCES_REQUEST', 'PATIENT_INSURANCES_SUCCESS', 'PATIENT_INSURANCES_FAILURE']
    }
  };
}

export function downloadInsuranceFile(syncId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/insurance/transfer/${syncId}/file?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'DOWNLOAD_INSURANCE_REQUEST',
        {
          type: 'DOWNLOAD_INSURANCE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'DOWNLOAD_INSURANCE_FAILURE']
    }
  }
}

export function deleteInsuranceFile(syncId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/insurance/transfer/${syncId}?${query}`,
      method: 'DELETE',
      types: ["DELETE_INSURANCE_REQUEST", "DELETE_INSURANCE_SUCCESS", "DELETE_INSURANCE_FAILURE"]
    }
  }
}

export function requestPatientInsurance(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/insurance?${query}`,
      method: 'GET',
      types: ["PATIENT_INSURANCE_REQUEST", "PATIENT_INSURANCE_SUCCESS", "PATIENT_INSURANCE_FAILURE"]
    }
  }
}

export function uploadPatientInsuranceFiles(params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('file', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/insurance/transfer?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['SERVICE_REQUEST_UPLOAD_FILES_REQUEST', 'SERVICE_REQUEST_UPLOAD_FILES_SUCCESS', 'SERVICE_REQUEST_UPLOAD_FILES_FAILURE']
    },
  };

}



// WEBPACK FOOTER //
// ./src/store/integrations/IntegrationsActions.js